<p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true"></p-toast>

<div class="action-detail-container p-6 w-full">
  <!-- Breadcrumb -->
  <div class="mb-4">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{ icon: 'pi pi-home', routerLink: '/axa/professionals-dashboard', ariaLabel: 'Home' }" [attr.aria-label]="'Breadcrumb navigation'"
    >
    </p-breadcrumb>
  </div>

  <!-- Page Header -->
  <div class="page-header mb-4">
    <div class="header-content">
      <div class="header-left">
        <button
          pButton
          icon="pi pi-arrow-left"
          class="p-button-text p-button-plain header-back-btn"
          (click)="goBack()"
          aria-label="Torna al dettaglio contratto"
          title="Torna al dettaglio contratto"
        ></button>
        <div>
          <h1 class="text-3xl font-bold m-0" style="color: #00125b">
            {{ action()?.actionName || 'Dettaglio Azione' }}
          </h1>
          <p class="text-color-secondary mt-2 mb-0">
            @if (action()?.id) {
              <span class="font-medium">ID Azione: {{ action()!.id }}</span>
              <span class="mx-2">•</span>
            }
            {{ actionTypeLabel() }}
          </p>
        </div>
      </div>
      <div class="header-right flex gap-2 align-items-center"></div>
    </div>
  </div>

  @if (isLoading()) {
    <div
      class="flex align-items-center justify-content-center"
      style="min-height: 400px"
      role="status"
      aria-live="polite"
    >
      <p-progress-spinner [attr.aria-label]="'Caricamento dettagli azione in corso'"></p-progress-spinner>
    </div>
  } @else if (action()) {
    <!-- ================= SECTION 1: INFORMAZIONI GENERALI ================= -->
    <section
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="info-generali-heading"
    >
      <div
        class="flex align-items-center justify-content-between mb-4 pb-3 border-bottom-1 border-200"
      >
        <div class="flex align-items-center gap-3">
          <i class="pi pi-file-edit text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="info-generali-heading" class="text-xl font-semibold m-0">
            Informazioni Generali
          </h2>
        </div>
        <p-tag [value]="actionStatusLabel()" [severity]="actionStatusSeverity()"></p-tag>
      </div>

      <div class="form-grid">
        <div class="item">
          <label for="contract-id">ID Contratto</label>
          <input
            id="contract-id"
            pInputText
            [value]="action()?.contractId || 'N/A'"
            [disabled]="true"
            class="w-full"
          />
        </div>
        <div class="item">
          <label for="action-id">ID Azione</label>
          <input
            id="action-id"
            pInputText
            [value]="action()?.id || 'N/A'"
            [disabled]="true"
            class="w-full"
          />
        </div>
        <div class="item">
          <label for="action-type">Tipo Azione</label>
          <input
            id="action-type"
            pInputText
            [value]="actionTypeLabel()"
            [disabled]="true"
            class="w-full"
          />
        </div>

        <div class="item full-width">
          <label for="action-name">
            Nome Azione <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input
            id="action-name"
            pInputText
            [(ngModel)]="action()!.actionName"
            [disabled]="!isEditModeGenerali()"
            class="w-full"
            [attr.aria-readonly]="!isEditModeGenerali()"
            [attr.aria-required]="isEditModeGenerali() ? 'true' : null"
            [attr.aria-invalid]="
              isEditModeGenerali() && !action()!.actionName.trim() ? 'true' : 'false'
            "
            [attr.aria-describedby]="
              isEditModeGenerali() && !action()!.actionName.trim()
                ? 'action-name-help action-name-error'
                : 'action-name-help'
            "
          />
          <small id="action-name-help" class="text-600"
            >Inserisci un nome chiaro per l'azione contrattuale.</small
          >
          @if (isEditModeGenerali() && !action()!.actionName.trim()) {
            <small id="action-name-error" class="p-error block mt-1" role="alert">
              Il nome azione è obbligatorio.
            </small>
          }
        </div>

        <div class="item full-width">
          <label for="description">Descrizione</label>
          <textarea
            id="description"
            pInputTextarea
            [(ngModel)]="action()!.description"
            [disabled]="!isEditModeGenerali()"
            rows="3"
            class="w-full"
            [attr.aria-readonly]="!isEditModeGenerali()"
            aria-describedby="description-help"
            placeholder="Inserisci una descrizione dell'azione..."
          ></textarea>
          <small id="description-help" class="text-600">
            Descrivi l'obiettivo o il contenuto dell'azione in modo sintetico.
          </small>
        </div>

        <div class="item">
          <label for="created-at">Data Creazione</label>
          <input
            id="created-at"
            pInputText
            [value]="formatDate(action()?.createdAt)"
            [disabled]="true"
            class="w-full"
          />
        </div>
        <div class="item">
          <label for="updated-at">Ultima Modifica</label>
          <input
            id="updated-at"
            pInputText
            [value]="formatDate(action()?.updatedAt)"
            [disabled]="true"
            class="w-full"
          />
        </div>
      </div>

      <!-- Button section footer -->
      <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (isEditModeGenerali()) {
          <p-button
            label="Annulla"
            icon="pi pi-times"
            [outlined]="true"
            size="small"
            (onClick)="toggleEditGenerali()" [attr.aria-label]="'Annulla modifiche informazioni generali'"
            pTooltip="Annulla modifiche"
            tooltipPosition="top"
            title="Annulla modifiche informazioni generali"
          ></p-button>
          <p-button
            label="Salva"
            icon="pi pi-check"
            size="small"
            (onClick)="saveSection('generali')" [attr.aria-label]="'Salva modifiche informazioni generali'"
            pTooltip="Salva modifiche"
            tooltipPosition="top"
            title="Salva modifiche informazioni generali"
          ></p-button>
        } @else if (isActionEditable()) {
          <p-button
            label="Modifica"
            icon="pi pi-pencil"
            [outlined]="true"
            size="small"
            [disabled]="hasAnySectionInEditMode()"
            (onClick)="toggleEditGenerali()"
            [ariaLabel]="
              hasAnySectionInEditMode()
                ? 'Modifica informazioni generali - disabilitato: completa o annulla le modifiche alla sezione corrente'
                : 'Modifica informazioni generali'
            "
            [pTooltip]="
              hasAnySectionInEditMode()
                ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                : 'Modifica sezione'
            "
            tooltipPosition="top"
          ></p-button>
        }
      </div>
    </section>

    <!-- ================= SECTION 2: CAMPI SPECIFICI PER TIPO ================= -->

    <!-- MODIFY_DURATION -->
    @if (showModifyDurationFields()) {
      <section
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="duration-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-calendar text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="duration-heading" class="text-xl font-semibold m-0">Modifica Durata</h2>
        </div>

        <div class="form-grid">
          <div class="item">
            <label for="new-end-date">Nuova Data Fine</label>
            <p-datepicker
              inputId="new-end-date"
              [(ngModel)]="action()!.newEndDate"
              [disabled]="!isEditModeSpecific()"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              class="w-full"
              [attr.aria-readonly]="!isEditModeSpecific()"
            ></p-datepicker>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeSpecific()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditSpecific()" [attr.aria-label]="'Annulla modifiche'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveSection('specific')" [attr.aria-label]="'Salva modifiche'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isActionEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditSpecific()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica sezione'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              [title]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica informazioni generali'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- MODIFY_SUBJECT -->
    @if (showModifySubjectFields()) {
      <section
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="subject-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-file-edit text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="subject-heading" class="text-xl font-semibold m-0">Modifica Oggetto</h2>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label for="new-subject">Nuovo Oggetto Contratto</label>
            <textarea
              id="new-subject"
              pInputTextarea
              [(ngModel)]="action()!.newContractSubject"
              [disabled]="!isEditModeSpecific()"
              rows="4"
              class="w-full"
              [attr.aria-readonly]="!isEditModeSpecific()"
              placeholder="Inserisci il nuovo oggetto del contratto..."
            ></textarea>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeSpecific()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditSpecific()" [attr.aria-label]="'Annulla modifiche'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveSection('specific')" [attr.aria-label]="'Salva modifiche'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isActionEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditSpecific()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica sezione'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              [title]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- MODIFY_ECONOMICS -->
    @if (showModifyFeesFields()) {
      <section
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="fees-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-euro text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="fees-heading" class="text-xl font-semibold m-0">Modifica Corrispettivi</h2>
        </div>

        <div class="form-grid">
          <div class="item">
            <label for="currency">Valuta</label>
            <p-select
              inputId="currency"
              [(ngModel)]="action()!.newCurrency"
              [options]="currencyOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              [disabled]="!isEditModeSpecific()"
              placeholder="Seleziona valuta"
              class="w-full"
              [attr.aria-readonly]="!isEditModeSpecific()"
            ></p-select>
          </div>

          <div class="item">
            <label for="total-contract-value">Valore Durata Contratto IVA Esclusa</label>
            <p-inputNumber
              inputId="total-contract-value"
              [(ngModel)]="action()!.newTotalContractValue"
              [disabled]="!isEditModeSpecific()"
              mode="currency"
              [currency]="action()?.newCurrency || 'EUR'"
              currencyDisplay="symbol"
              locale="it-IT"
              class="w-full"
              [attr.aria-readonly]="!isEditModeSpecific()"
            ></p-inputNumber>
          </div>

          <div class="item">
            <label for="annual-value">Valore Annuale IVA Esclusa</label>
            <p-inputNumber
              inputId="annual-value"
              [(ngModel)]="action()!.newAnnualValue"
              [disabled]="!isEditModeSpecific()"
              mode="currency"
              [currency]="action()?.newCurrency || 'EUR'"
              currencyDisplay="symbol"
              locale="it-IT"
              class="w-full"
              [attr.aria-readonly]="!isEditModeSpecific()"
            ></p-inputNumber>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeSpecific()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditSpecific()" [attr.aria-label]="'Annulla modifiche'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveSection('specific')" [attr.aria-label]="'Salva modifiche'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isActionEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditSpecific()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica sezione'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              [title]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- EXTEND_PARTIES -->
    @if (showExtendPartiesFields()) {
      <section
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="parties-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-users text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="parties-heading" class="text-xl font-semibold m-0">
            Estensione Parti Contrattuali
          </h2>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label>Entity Coinvolte</label>
            @if (isEditModeSpecific()) {
              <div class="flex flex-column gap-3">
                @for (entity of getActionInvolvedEntities(); track $index) {
                  <div class="surface-50 border-round p-4">
                    <div class="flex justify-content-between align-items-center mb-3">
                      <h4 class="text-md font-semibold m-0">Entity Coinvolta #{{ $index + 1 }}</h4>
                      <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        size="small"
                        [text]="true"
                        (onClick)="removeInvolvedEntity($index)"
                        [disabled]="getActionInvolvedEntities().length === 1"
                      ></p-button>
                    </div>

                    <div class="grid">
                      <div class="field col-12 md:col-4">
                        <label [for]="'detail-entity-code-' + $index">Denominazione Entità</label>
                        <p-select
                          [inputId]="'detail-entity-code-' + $index"
                          [(ngModel)]="action()!.newInvolvedEntities![$index].entityCode"
                          [ngModelOptions]="{ standalone: true }"
                          [options]="getAvailableInvolvedEntityOptions($index)"
                          optionLabel="entityDescription"
                          optionValue="entityCode"
                          placeholder="Seleziona entità"
                          (onChange)="onInvolvedEntityChange($index)"
                          class="w-full"
                        ></p-select>
                      </div>

                      <div class="field col-12 md:col-4">
                        <label [for]="'detail-signatory-name-' + $index">
                          Firmato da ({{ getInvolvedEntityLabel(entity.entityCode) }})
                        </label>
                        <input
                          [id]="'detail-signatory-name-' + $index"
                          pInputText
                          [(ngModel)]="action()!.newInvolvedEntities![$index].signatoryName"
                          [ngModelOptions]="{ standalone: true }"
                          class="w-full"
                        />
                      </div>

                      <div class="field col-12 md:col-4">
                        <label [for]="'detail-signatory-role-' + $index">
                          Ruolo Firmatario ({{ getInvolvedEntityLabel(entity.entityCode) }})
                        </label>
                        <input
                          [id]="'detail-signatory-role-' + $index"
                          pInputText
                          [(ngModel)]="action()!.newInvolvedEntities![$index].signatoryRole"
                          [ngModelOptions]="{ standalone: true }"
                          class="w-full"
                        />
                      </div>
                    </div>
                  </div>
                }

                <div class="flex justify-content-end">
                  <p-button
                    label="Aggiungi Entity Coinvolta"
                    icon="pi pi-plus"
                    size="small"
                    (onClick)="addInvolvedEntity()"
                    [disabled]="!canAddMoreInvolvedEntities()"
                  ></p-button>
                </div>
              </div>
            } @else {
              <div class="flex flex-column gap-3">
                @for (entity of getActionInvolvedEntities(); track $index) {
                  <div class="surface-50 border-round p-4">
                    <div class="grid">
                      <div class="field col-12 md:col-4">
                        <label [for]="'detail-entity-view-' + $index">Denominazione Entità</label>
                        <input
                          [id]="'detail-entity-view-' + $index"
                          pInputText
                          [value]="getInvolvedEntityLabel(entity.entityCode)"
                          [disabled]="true"
                          class="w-full"
                        />
                      </div>

                      <div class="field col-12 md:col-4">
                        <label [for]="'detail-signatory-name-view-' + $index">
                          Firmato da ({{ getInvolvedEntityLabel(entity.entityCode) }})
                        </label>
                        <input
                          [id]="'detail-signatory-name-view-' + $index"
                          pInputText
                          [value]="entity.signatoryName || '-'"
                          [disabled]="true"
                          class="w-full"
                        />
                      </div>

                      <div class="field col-12 md:col-4">
                        <label [for]="'detail-signatory-role-view-' + $index">
                          Ruolo Firmatario ({{ getInvolvedEntityLabel(entity.entityCode) }})
                        </label>
                        <input
                          [id]="'detail-signatory-role-view-' + $index"
                          pInputText
                          [value]="entity.signatoryRole || '-'"
                          [disabled]="true"
                          class="w-full"
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeSpecific()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditSpecific()" [attr.aria-label]="'Annulla modifiche'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveSection('specific')" [attr.aria-label]="'Salva modifiche'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isActionEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditSpecific()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica sezione'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              [title]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- RENEW_CONTRACT -->
    @if (showRenewFields()) {
      <section
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="renew-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-refresh text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="renew-heading" class="text-xl font-semibold m-0">Rinnovo Contratto</h2>
        </div>

        <div class="form-grid">
          <!-- ID Nuovo Contratto Clonato (solo post-attivazione e NON annullata) -->
          @if (action()!.renewedContractId && action()!.status !== 'CANCELED') {
            <div class="item full-width">
              <label for="renewed-contract-id">ID Nuovo Contratto Creato</label>
              <div
                class="p-3 bg-green-50 border-1 border-green-200 border-round flex align-items-center gap-2"
              >
                <i class="pi pi-check-circle text-green-600" aria-hidden="true"></i>
                <span class="font-semibold text-green-700"
                  >Contratto #{{ action()!.renewedContractId }}</span
                >
                <p-button
                  icon="pi pi-external-link"
                  [text]="true"
                  [rounded]="true"
                  size="small"
                  severity="success"
                  (onClick)="navigateToContract(action()!.renewedContractId!)"
                  [attr.aria-label]="'Apri contratto ' + action()!.renewedContractId"
                  pTooltip="Apri il nuovo contratto"
                  tooltipPosition="top"
                  title="Apri il nuovo contratto"
                ></p-button>
              </div>
            </div>
          }

          <div class="item full-width">
            <label for="renewal-notes">Note Rinnovo</label>
            <textarea
              id="renewal-notes"
              pInputTextarea
              [(ngModel)]="action()!.renewalNotes"
              [disabled]="!isEditModeSpecific()"
              rows="4"
              class="w-full"
              [attr.aria-readonly]="!isEditModeSpecific()"
              placeholder="Inserisci le note per il rinnovo del contratto..."
            ></textarea>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeSpecific()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditSpecific()" [attr.aria-label]="'Annulla modifiche'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveSection('specific')" [attr.aria-label]="'Salva modifiche'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isActionEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditSpecific()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica sezione'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              [title]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- TERMINATION -->
    @if (showTerminateFields()) {
      <section
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="terminate-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-times-circle text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="terminate-heading" class="text-xl font-semibold m-0">Recesso Contratto</h2>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label for="termination-reason">Motivo Recesso</label>
            <textarea
              id="termination-reason"
              pInputTextarea
              [(ngModel)]="action()!.terminationReason"
              [disabled]="!isEditModeSpecific()"
              rows="4"
              class="w-full"
              [attr.aria-readonly]="!isEditModeSpecific()"
              placeholder="Inserisci il motivo del recesso..."
            ></textarea>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeSpecific()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditSpecific()" [attr.aria-label]="'Annulla modifiche'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveSection('specific')" [attr.aria-label]="'Salva modifiche'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isActionEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditSpecific()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica sezione'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: TEMPLATE DOCUMENTO ================= -->
    @if (isActionEditable()) {
      <section
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="template-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-file-edit text-2xl" style="color: #667eea" aria-hidden="true"></i>
          <h2 id="template-heading" class="text-xl font-semibold m-0" style="color: #00125b">
            Template Documento
          </h2>
        </div>

        <!-- Template selezionato -->
        <div class="grid">
          <div class="col-12">
            @if (isEditModeTemplate()) {
              <!-- Edit mode: Card con possibilità di cambiare -->
              @if (hasTemplate()) {
                <div class="surface-100 border-round p-4 border-1 border-300">
                  <div class="flex justify-content-between align-items-start">
                    <div class="flex-1">
                      <div class="flex align-items-center gap-2 mb-2">
                        <i class="pi pi-file text-xl" style="color: #00125b"></i>
                        <div>
                          <p class="text-sm text-color-secondary m-0 mb-1">Template selezionato</p>
                          <h4 class="text-lg font-semibold m-0">
                            {{ templateName() || 'Caricamento...' }}
                          </h4>
                          <p class="text-xs text-color-secondary m-0 mt-1">
                            ID: {{ action()?.selectedTemplateId || 'N/A' }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="flex gap-2">
                      <p-button
                        icon="pi pi-pencil"
                        [text]="true"
                        [rounded]="true"
                        severity="secondary"
                        pTooltip="Cambia template"
                        tooltipPosition="top"
                        (onClick)="openTemplateDialog()" [attr.aria-label]="'Cambia template documento'"
                        title="Cambia template documento"
                      ></p-button>
                    </div>
                  </div>
                </div>
              } @else {
                <!-- Nessun template selezionato in edit mode -->
                <p-button
                  label="Seleziona dal Registro Template"
                  icon="pi pi-search"
                  [outlined]="true"
                  styleClass="w-full justify-content-center"
                  (onClick)="openTemplateDialog()" [attr.aria-label]="'Seleziona template documento dal registro'"
                  title="Seleziona template documento dal registro"
                ></p-button>
                <small class="text-muted block mt-2">
                  <i class="pi pi-info-circle mr-1"></i>
                  Seleziona un template documento dal registro
                </small>
              }
            } @else {
              <!-- View mode -->
              @if (hasTemplate()) {
                <div class="surface-100 border-round p-4 border-1 border-200">
                  <div class="flex align-items-center gap-2">
                    <i class="pi pi-file text-xl" style="color: #00125b"></i>
                    <div>
                      <p class="text-sm text-color-secondary m-0 mb-1">Template selezionato</p>
                      <span class="font-semibold">{{ templateName() || 'Caricamento...' }}</span>
                      <p class="text-xs text-color-secondary m-0 mt-1">
                        ID: {{ action()?.selectedTemplateId || 'N/A' }}
                      </p>
                    </div>
                  </div>
                </div>
              } @else {
                <div class="text-muted">Non selezionato</div>
              }
            }
          </div>
        </div>

        @if (!isEditModeTemplate() && hasTemplate()) {
          <!-- Pulsante Genera Documento -->
          <div class="mt-4 flex justify-content-center">
            <p-button
              label="Genera Documento"
              icon="pi pi-file-word"
              size="large"
              styleClass="p-button-success"
              (onClick)="generateDocument()" [attr.aria-label]="&quot;Genera documento dall'azione&quot;"
              title="Genera documento dall'azione utilizzando il template selezionato"
              pTooltip="Genera documento dall'azione utilizzando il template selezionato"
              tooltipPosition="top"
            ></p-button>
          </div>

          <div class="mt-3 p-3 bg-blue-50 border-1 border-blue-200 border-round">
            <div class="flex align-items-start gap-2">
              <i class="pi pi-info-circle text-blue-600 mt-1" aria-hidden="true"></i>
              <div class="text-sm text-blue-900">
                <p class="m-0 mb-2 font-semibold">Come funziona la generazione documento</p>
                <p class="m-0">
                  Usa il pulsante "Genera Documento" per creare il documento dell'azione utilizzando
                  il template selezionato. Se vuoi utilizzare un template diverso, clicca su
                  "Modifica" per cambiarlo prima di generare il documento.
                </p>
              </div>
            </div>
          </div>
        }

        <!-- Footer con bottoni edit/save -->
        @if (isActionEditable()) {
          <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
            @if (isEditModeTemplate()) {
              <p-button
                label="Annulla"
                icon="pi pi-times"
                severity="secondary"
                [outlined]="true"
                (onClick)="toggleEditTemplate()" [attr.aria-label]="'Annulla modifiche template'"
                pTooltip="Annulla modifiche"
                tooltipPosition="top"
                title="Annulla modifiche template"
              ></p-button>
              <p-button
                label="Salva"
                icon="pi pi-check"
                (onClick)="saveTemplate()" [attr.aria-label]="'Salva modifiche template'"
                pTooltip="Salva modifiche"
                tooltipPosition="top"
                title="Salva modifiche template"
              ></p-button>
            } @else {
              <p-button
                label="Modifica"
                icon="pi pi-pencil"
                [outlined]="true"
                [disabled]="hasAnySectionInEditMode()"
                (onClick)="toggleEditTemplate()"
                [ariaLabel]="
                  hasAnySectionInEditMode()
                    ? 'Modifica template - disabilitato: completa o annulla le modifiche alla sezione corrente'
                    : 'Modifica template'
                "
                [pTooltip]="
                  hasAnySectionInEditMode()
                    ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                    : 'Modifica template'
                "
                [title]="
                  hasAnySectionInEditMode()
                    ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                    : 'Modifica template'
                "
                tooltipPosition="top"
              ></p-button>
            }
          </div>
        }
      </section>
    }

    <!-- ================= SECTION: DOCUMENTO FIRMATO ================= -->
    <section
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="signed-doc-heading"
    >
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-file-pdf text-2xl" style="color: #00125b" aria-hidden="true"></i>
        <h2 id="signed-doc-heading" class="text-xl font-semibold m-0">Documento Firmato</h2>
      </div>

      <div class="flex flex-column gap-3">
        <!-- Stato documento -->
        @if (signedDocumentUrl()) {
          <div
            class="flex align-items-center gap-3 p-3 bg-green-50 border-1 border-green-200 border-round"
            role="status"
            aria-live="polite"
          >
            <i class="pi pi-check-circle text-green-600 text-xl" aria-hidden="true"></i>
            <div class="flex-1">
              <p class="m-0 font-semibold text-green-900">Documento caricato</p>
              <p class="m-0 text-sm text-green-800">
                Il documento firmato dell'azione è disponibile
              </p>
            </div>
            <div class="flex gap-2">
              <p-button
                label="Scarica"
                icon="pi pi-download"
                severity="info"
                size="small"
                (onClick)="downloadSignedDocument()" [attr.aria-label]="'Scarica documento firmato'"
                title="Scarica documento firmato"
                pTooltip="Scarica il documento"
                tooltipPosition="top"
              ></p-button>
              @if (isActionEditable()) {
                <p-button
                  icon="pi pi-trash"
                  severity="danger"
                  [outlined]="true"
                  [rounded]="true"
                  size="small"
                  (onClick)="deleteSignedDocument()" [attr.aria-label]="'Rimuovi documento firmato'"
                  title="Rimuovi documento firmato"
                  pTooltip="Rimuovi documento"
                  tooltipPosition="top"
                ></p-button>
              }
            </div>
          </div>
        } @else {
          <div
            class="flex align-items-center gap-3 p-3 bg-blue-50 border-1 border-blue-200 border-round"
            role="status"
            aria-live="polite"
          >
            <i class="pi pi-info-circle text-blue-600 text-xl" aria-hidden="true"></i>
            <div class="flex-1">
              <p class="m-0 font-semibold text-blue-900">Nessun documento caricato</p>
              @if (action()?.actionType !== 'RENEW_CONTRACT') {
                <p class="m-0 text-sm text-blue-800">Carica il documento firmato dell'azione</p>
              }
            </div>
          </div>
        }

        <!-- Upload - mostra solo se non c'è già un documento caricato E l'azione è editabile -->
        @if (!signedDocumentUrl() && isActionEditable()) {
          <div class="form-grid">
            <div class="item full-width">
              <label for="signed-document-upload" class="block mb-2 font-semibold">
                Carica Documento Firmato
                <span class="text-sm font-normal text-600 ml-2">(PDF, DOC, DOCX - Max 10MB)</span>
              </label>
              <p-fileupload
                #signedDocUpload
                name="signedDocument"
                [auto]="true"
                [customUpload]="true"
                (uploadHandler)="onSignedDocumentSelect($event)"
                accept=".pdf,.doc,.docx"
                [maxFileSize]="10485760"
                [disabled]="isUploadingSignedDoc()"
                [showUploadButton]="false"
                [showCancelButton]="false"
                styleClass="custom-fileupload"
                [attr.aria-label]="'Carica documento firmato dell\'azione'"
                class="w-full"
              >
                <ng-template pTemplate="header">
                  <!-- Header vuoto per nascondere i pulsanti di default -->
                </ng-template>
                <ng-template
                  pTemplate="content"
                  let-files
                  let-chooseCallback="chooseCallback"
                  let-removeFileCallback="removeFileCallback"
                >
                  @if (isUploadingSignedDoc()) {
                    <div
                      class="flex align-items-center justify-content-center gap-2 p-5"
                      role="status"
                      aria-live="polite"
                    >
                      <i class="pi pi-spin pi-spinner text-2xl" aria-hidden="true"></i>
                      <span class="font-semibold">Caricamento in corso...</span>
                    </div>
                  } @else if (uploadErrored()) {
                    <div
                      class="flex flex-column align-items-center justify-content-center p-5 text-center"
                      role="alert"
                    >
                      <i
                        class="pi pi-exclamation-triangle text-6xl mb-3 text-red-500"
                        aria-hidden="true"
                      ></i>
                      <p class="m-0 mb-2 font-semibold text-900">Caricamento Fallito</p>
                      <p class="m-0 mb-3 text-sm text-600">
                        Si è verificato un errore durante il caricamento del documento
                      </p>
                      <p-button
                        label="Riprova Caricamento"
                        icon="pi pi-refresh"
                        (onClick)="retryUpload()"
                        severity="warn"
                        [outlined]="true" [attr.aria-label]="'Riprova il caricamento del documento'"
                        title="Riprova il caricamento del documento"
                      ></p-button>
                    </div>
                  } @else if (files && files.length === 0) {
                    <div
                      class="flex flex-column align-items-center justify-content-center p-5 text-center"
                    >
                      <i class="pi pi-cloud-upload text-6xl mb-3 text-400" aria-hidden="true"></i>
                      <p class="m-0 mb-2 font-semibold text-900">
                        Trascina qui il documento firmato
                      </p>
                      <p class="m-0 mb-3 text-sm text-600">oppure</p>
                      <p-button
                        label="Scegli File"
                        icon="pi pi-folder-open"
                        (onClick)="chooseCallback()"
                        [outlined]="true" [attr.aria-label]="'Seleziona file da caricare'"
                        title="Seleziona file da caricare"
                      ></p-button>
                    </div>
                  } @else {
                    <div class="p-3">
                      @for (file of files; track file.name) {
                        <div
                          class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round mb-2"
                        >
                          <div class="flex align-items-center gap-3">
                            <i class="pi pi-file text-3xl text-primary" aria-hidden="true"></i>
                            <div>
                              <div class="font-semibold text-900">{{ file.name }}</div>
                              <small class="text-600">{{ formatFileSize(file.size) }}</small>
                            </div>
                          </div>
                          <p-button
                            icon="pi pi-times"
                            [rounded]="true"
                            [text]="true"
                            severity="danger"
                            (onClick)="removeFileCallback(file)"
                            [ariaLabel]="'Rimuovi ' + file.name"
                            [title]="'Rimuovi ' + file.name"
                          ></p-button>
                        </div>
                      }
                      <p-button
                        label="Scegli un Altro File"
                        icon="pi pi-folder-open"
                        (onClick)="chooseCallback()"
                        [outlined]="true"
                        size="small"
                        class="w-full mt-2" [attr.aria-label]="'Seleziona un file diverso da caricare'"
                        title="Seleziona un file diverso da caricare"
                      ></p-button>
                    </div>
                  }
                </ng-template>
              </p-fileupload>
            </div>
          </div>

          <!-- Info aggiuntive -->
          <div class="flex align-items-start gap-2 p-3 bg-gray-50 border-round">
            <i class="pi pi-info-circle text-gray-600" aria-hidden="true"></i>
            <div class="text-sm text-gray-700">
              <p class="m-0 mb-2 font-semibold">Informazioni importanti:</p>
              <ul class="m-0 pl-3">
                <li>Carica solo il documento ufficiale e firmato dell'azione</li>
                <li>Formati supportati: PDF, DOC, DOCX</li>
                <li>Dimensione massima: 10 MB</li>
              </ul>
            </div>
          </div>
        }
      </div>
    </section>

    <!-- ================= SECTION: ATTIVAZIONE AZIONE ================= -->
    @if (isActionEditable()) {
      <section
        class="surface-0 border-round p-5 mb-4 shadow-2"
        role="region"
        aria-labelledby="activate-action-heading"
        style="border: 2px solid #00875a"
      >
        <div class="flex align-items-center justify-content-between flex-wrap gap-4">
          <div class="flex align-items-start gap-3">
            <i class="pi pi-check-circle text-4xl" style="color: #00875a" aria-hidden="true"></i>
            <div>
              <h2
                id="activate-action-heading"
                class="text-2xl font-bold m-0 mb-2"
                style="color: #00875a"
              >
                Attivazione Azione
              </h2>
              <p class="m-0 text-700 mb-2">
                Verifica che tutte le informazioni siano corrette e attiva l'azione per renderla
                operativa.
              </p>
              @if (action()?.actionType === 'RENEW_CONTRACT') {
                <!-- RENEW_CONTRACT: non richiede documento -->
                <div
                  class="flex align-items-center gap-2 p-3 bg-green-50 border-1 border-green-200 border-round"
                  role="status"
                  aria-live="polite"
                >
                  <i class="pi pi-info-circle text-green-600" aria-hidden="true"></i>
                  <span class="text-sm text-green-900 font-semibold">
                    L'azione è pronta per essere attivata (il documento firmato non è obbligatorio
                    per il rinnovo)
                  </span>
                </div>
              } @else if (!signedDocumentUrl() || uploadErrored()) {
                <!-- Altri tipi: richiedono documento -->
                <div
                  class="flex align-items-center gap-2 p-3 bg-orange-50 border-1 border-orange-200 border-round"
                  role="alert"
                >
                  <i class="pi pi-exclamation-triangle text-orange-600" aria-hidden="true"></i>
                  <span class="text-sm text-orange-900 font-semibold">
                    @if (uploadErrored()) {
                      Il caricamento del documento è fallito. Riprova prima di attivare l'azione
                    } @else {
                      Prima di attivare l'azione è necessario caricare il documento firmato
                    }
                  </span>
                </div>
              } @else {
                <div
                  class="flex align-items-center gap-2 p-3 bg-green-50 border-1 border-green-200 border-round"
                  role="status"
                  aria-live="polite"
                >
                  <i class="pi pi-info-circle text-green-600" aria-hidden="true"></i>
                  <span class="text-sm text-green-900 font-semibold">
                    L'azione è pronta per essere attivata
                  </span>
                </div>
              }
            </div>
          </div>
          <div class="flex gap-3">
            <p-button
              label="Attiva Azione"
              icon="pi pi-bolt"
              size="large"
              [disabled]="!canActivateAction()"
              [ariaLabel]="activateActionTooltip()"
              [title]="activateActionTooltip()"
              [pTooltip]="activateActionTooltip()"
              tooltipPosition="left"
              styleClass="p-button-success"
              (onClick)="activateAction()"
            ></p-button>
          </div>
        </div>
      </section>
    }
  } @else {
    <div
      class="flex align-items-center justify-content-center flex-column"
      style="min-height: 400px"
    >
      <i class="pi pi-exclamation-triangle text-6xl mb-4" style="color: #ffc107"></i>
      <h3 class="text-2xl font-semibold mb-2">Azione non trovata</h3>
      <p class="text-color-secondary mb-4">L'azione richiesta non è disponibile o non esiste.</p>
      <p-button
        label="Torna al contratto"
        icon="pi pi-arrow-left"
        (onClick)="goBack()" [attr.aria-label]="'Torna al dettaglio contratto'"
        title="Torna al dettaglio contratto"
      ></p-button>
    </div>
  }
</div>

<!-- Template Selection Dialog -->
<p-dialog
  [(visible)]="showTemplateDialog"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [ariaLabel]="'Selezione template documento'"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-semibold">Seleziona Template Documento</span>
  </ng-template>

  <div class="p-4">
    <app-registry-table
      [columns]="templateColumns"
      [data]="templateTableData()"
      (onSelectClick)="selectTemplate($event)"
    ></app-registry-table>
  </div>
</p-dialog>
